export const SUBSCRIPTION_DIRECTIONS_MSG = "Create a sponsored advertising campaign for your job (Optional)"
export const JOB_POSTING_PKG_MSG= "Select your job posting packages"

// export const FREE_JOB_POSTING_BUNDLE_ID = 132;
// export const BEHAVORIAL_ASSESMENT_BUNDLE_ID = 179;

//  Staging Bundles
export const FREE_JOB_POSTING_BUNDLE_ID = Number(process.env.REACT_APP_FREE_JOB_POSTING_BUNDLE_ID);
export const BEHAVORIAL_ASSESMENT_BUNDLE_ID = Number(process.env.REACT_APP_BEHAVORIAL_ASSESMENT_BUNDLE_ID);
